const initState = {
    consumptionCartList: [],
    wishListId: undefined,
    cartProductCount: 0,
    cartType: '',
};

const SET_CONSUMPTION_CART_LIST = "SET_CONSUMPTION_CART_LIST";
const SET_CART_WISHLIST_ID = "SET_CART_WISHLIST_ID";
const SET_CART_PRODUCT_COUNT = "SET_CART_PRODUCT_COUNT";
const SET_CART_TYPE = "SET_CART_TYPE";

export const setConsumptionCartList = (data) => ({ type: SET_CONSUMPTION_CART_LIST, payload: data });
export const setInventoryWishlistId = (data) => ({ type: SET_CART_WISHLIST_ID, payload: data });
export const setCartProductCount = (data) => ({ type: SET_CART_PRODUCT_COUNT, payload: data });
export const setCartType = (data) => ({ type: SET_CART_TYPE, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_CONSUMPTION_CART_LIST:
            return { ...state, consumptionCartList: action.payload };
        case SET_CART_WISHLIST_ID:
            return { ...state, wishListId: action.payload };
        case SET_CART_PRODUCT_COUNT:
            return { ...state, cartProductCount: action.payload };
        case SET_CART_TYPE:
            return { ...state, cartType: action.payload };
        default:
            return state;
    }
}
